import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import { Routes } from "../routes";

// pages
import Login from "./Login";
import Dashboard from "./Dashboard";
import Reports from "./Reports";
import ReportPreview from "./ReportPreview";
import Settings from "./Settings";
import AttendancePage from "./AttendancePage";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
import ProtectedRoute from "../components/ProtectedRoute";

const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => ( <> <Preloader show={loaded ? false : true} /> <Component {...props} /> </> ) } />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <Preloader show={loaded ? false : true} />
        <Sidebar />

        <main className="content">
          <Navbar />
          <Component {...props} />
          <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
        </main>
      </>
    )}
    />
  );
};

const NotFound = () => {
  const history = useHistory();
  
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const redirectPath = token ? Routes.Dashboard.path : Routes.Login.path;
    console.log('404 - Redirigiendo a:', redirectPath);
    history.replace(redirectPath);
  }, [history]);
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <h2>Página no encontrada</h2>
      <p>Redirigiendo...</p>
    </div>
  );
};

export default () => (
  <Switch>
    <RouteWithLoader exact path={Routes.Login.path} component={Login} />
    <RouteWithLoader path={Routes.Attendance.path} component={AttendancePage} />
    <ProtectedRoute exact path={Routes.Dashboard.path} render={(props) => <RouteWithSidebar component={Dashboard} {...props} />} />
    <ProtectedRoute exact path={Routes.Reports.path} render={(props) => <RouteWithSidebar component={Reports} {...props} />} />
    <ProtectedRoute path={Routes.ReportPreview.path} render={(props) => <RouteWithSidebar component={ReportPreview} {...props} />} />
    <ProtectedRoute exact path={Routes.Settings.path} render={(props) => <RouteWithSidebar component={Settings} {...props} />} />
    
    {/* Ruta 404 */}
    <Route path="*" component={NotFound} />
  </Switch>
);